import { observer } from 'mobx-react-lite'
import { withPrefix } from 'gatsby'
import React from 'react'
import { useStore } from '../../../../../../hooks/useStore';

const LocationListCityMenu = () => {
    return (
        <div className='location-city-menu'>
            <ActiveCity/>
            <CitiesList/>
            <DropdownArrow/>
            <style jsx>{`
                div {
                    background: white;
                    border-radius: 8px;
                    overflow: hidden;
                    cursor: pointer;
                    width: 142px;
                }
            `}</style>
        </div>
    )
}

const DropdownArrow = observer(() => {
    const {uiStore: {home__locationList__cityMenuOpen}} = useStore();
    if (home__locationList__cityMenuOpen) return null
    
    return (
        <React.Fragment>
            <img src={withPrefix('/images/home-arrow.svg')} alt=""    />
            
            <style jsx>{`   
                img {
                    width: 20px;
                    position: absolute;
                    top: 2px;
                    right: 6px;
                }

                @media (max-width: 769px), (pointer: coarse) {
                    img {
                        top: 5px;
                    }
                }
            `}</style>
        </React.Fragment>
    )
});

const ActiveCity = observer(() => {
    const {uiStore: {home__locationList__activeCity, toggleLocationCityMenu}, cursorStore: {handleMouseEnter, handleMouseLeave}} = useStore();

    return (
        <City 
            data={home__locationList__activeCity} 
            onMouseEnter={() => handleMouseEnter("action")}
            onMouseLeave={handleMouseLeave}
            onClick={toggleLocationCityMenu} 
        />
    )
});

const CitiesList = observer(() => {
    const {uiStore: {home__locationList__activeCity, home__locationList__cityMenuOpen, setActiveLocationCity}, cursorStore: {handleMouseEnter, handleMouseLeave}} = useStore();
    if (!home__locationList__cityMenuOpen) return null;

    const cities = [
        "Atlanta",
        "Buffalo",
        "Chicago",
        "Detroit",
        "LA",
        "Philadelphia",
    ];

    return (
        <div>
            {cities.map(city => {
                if (home__locationList__activeCity === city) return null
                return <City 
                            data={city} 
                            onClick={() => setActiveLocationCity(city)}
                            onMouseEnter={() => {
                                handleMouseEnter("action");
                            }}
                            onMouseLeave={handleMouseLeave}
                        />
            })}
        </div>
    )
})

const City = ({data, onClick = null, onMouseEnter = null, onMouseLeave = null}) => {
    return (
        <div 
            onClick={() => {
                onClick();
                onMouseLeave();
            }}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            <h6 className='text-xs'>
                {data}
            </h6>
            <style jsx>{`
                div {
                    padding: 8px 24px;
                    cursor: pointer;
                }
                div:hover {
                    background: #eaeaea;
                }
                h6 {
                    user-select: none;
                }

                @media (max-width: 769px), (pointer: coarse) {
                    div {
                        padding: 12px 30px;
                    }
                }
            `}</style>
        </div>
    )
}
export default LocationListCityMenu